import { render, staticRenderFns } from "./BtnMethodPayment.vue?vue&type=template&id=211c511a&scoped=true&"
import script from "./BtnMethodPayment.vue?vue&type=script&lang=js&"
export * from "./BtnMethodPayment.vue?vue&type=script&lang=js&"
import style0 from "./BtnMethodPayment.vue?vue&type=style&index=0&id=211c511a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211c511a",
  null
  
)

export default component.exports